// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__oA5rB","profile":"style_profile__LGw4T"};